import styled from "styled-components";
import media from "styled-media-query";

import iconClose from "../../assets/icon-close.svg";
import linesModal from "../../assets/lines-modal.svg";

export const Modal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  border: 2px solid #000;
  background-color: #3cd1c0;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 720px;

  .header {
    display: flex;
    align-items: center;
    padding-top: 12px;
    padding-bottom: 12px;
    border-bottom: 2px solid #000;

    .lines {
      margin-left: 52px;
      margin-right: 52px;
      width: 100%;
      height: 32px;
      background-image: url(${linesModal});
      background-size: auto 100%;
    }

    .close {
      flex-shrink: 0;
      width: 42px;
      height: 42px;
      border: 2px solid #000;
      margin-right: 14px;
      background-image: url(${iconClose});
      background-position: center;
    }
  }

  .body {
    padding: 36px;
    margin: 20px 40px 30px;
    background-color: #000;
    color: #fff;
    text-align: center;

    p {
      font-size: 36px;
      font-weight: 700;

      ${media.lessThan("576px")`
				font-size: 16px;
			`}

      &.subline {
        font-size: 20px;
        font-weight: 500;
        ${media.lessThan("576px")`
					font-size: 10px;
					font-weight: 500;
				`}
      }
    }

    p + p {
      margin-top: 12px;
    }
  }
`;
